import React from 'react';
import VisitingClinicPage from './VisitingClinicPage';

const VisitingClinicPortMacquarie = () => (
  <VisitingClinicPage
    seo={{
      title: 'Autism, ADHD & Learning Assessments Port Macquarie | Clinical Minds Psychology',
      description: 'Full neurodevelopmental assessments at regular visiting clinics in Port Macquarie: autism, ADHD, FASD and learning disorders, children to adults. First appointment by Zoom, then one visit covers both assessment days. Enquire about upcoming clinic dates.',
      canonicalUrl: 'https://www.clinicalminds.net/visiting-clinics/port-macquarie'
    }}
    location="Port Macquarie"
    regionPhrase="the Mid North Coast and Hastings region"
  />
);

export default VisitingClinicPortMacquarie;
